import { NOTES_GET, NOTE_GET } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
};

const notesGet = (state, payload) => {
  let total = payload?.notes?.total ?? state.total;
  let items = payload?.notes?.items;
  
  return {
    ...state,
    total: total,
    items: items,
  };
};

const noteGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.note.id + ''),
      payload.note,
    ],
  };
};

export default createReducer(initialState, {
  [NOTES_GET]: notesGet,
  [NOTE_GET]: noteGet,
});
